import { FETCH_TYPE } from '../actionTypes.js';
/**
 * Requesting a fetch to begin
 */

export default function createFetch(endpoint, _ref) {
  let {
    args
  } = _ref;
  const key = endpoint.key(...args);
  let resolve = 0;
  let reject = 0;
  const promise = new Promise((a, b) => {
    [resolve, reject] = [a, b];
  });
  const meta = {
    schema: endpoint.schema,
    type: endpoint.sideEffect ? 'mutate' : 'read',
    args,
    key,
    throttle: !endpoint.sideEffect,
    options: endpoint,
    resolve,
    reject,
    promise,
    createdAt: Date.now()
  };

  if (endpoint.update) {
    meta.update = endpoint.update;
  }

  if (endpoint.optimisticUpdate) {
    meta.optimisticResponse = endpoint.optimisticUpdate(...args);
  }

  return {
    type: FETCH_TYPE,
    payload: () => endpoint(...args),
    meta,
    endpoint
  };
}
/** Future action shape
{
  type: FETCH_TYPE,
  endpoint,
  meta: {
    args,
    createdAt,
    promise,
    resolve,
    reject,
  }
} */